var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownloadSpreadsheet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "next_button",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 174,
    height: 34,
    viewBox: "0 0 174 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_222",
    "data-name": "Rectangle 222",
    width: 20,
    height: 20,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1840",
    "data-name": "Group 1840",
    transform: "translate(30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_293",
    "data-name": "Rectangle 293",
    transform: "translate(-30)",
    fill: "#e4e4e4",
    stroke: "#bfbfbf",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174,
    height: 34,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 172,
    height: 32,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1839",
    "data-name": "Group 1839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icono_descargar",
    transform: "translate(118 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_33",
    "data-name": "Mask Group 33",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(3.59 3.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M.49,363.832a.679.679,0,0,1-.484-.554.644.644,0,0,1,.615-.734c.03,0,.06,0,.09,0h11.4a.65.65,0,0,1,.708.585.642.642,0,0,1-.409.666c-.027.011-.052.025-.079.038Z",
    transform: "translate(0 -351.651)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M89.627,7.417a.789.789,0,0,1,.09-.139q.957-.965,1.918-1.927a.647.647,0,0,1,.99.834c-.035.042-.075.081-.114.12L89.463,9.353a.662.662,0,0,1-1.075,0Q86.842,7.809,85.3,6.265a.648.648,0,1,1,.894-.936c.316.307.623.623.934.935l1.018,1.021c.035.035.072.068.137.129v-.2q0-3.222,0-6.443a.794.794,0,0,1,.133-.511.659.659,0,0,1,.684-.233.635.635,0,0,1,.462.534,2.045,2.045,0,0,1,.012.24q0,3.207,0,6.413v.173l.057.035",
    transform: "translate(-82.515 -0.001)",
    fill: "#707070"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "Descargar_planillas",
    "data-name": "Descargar planillas",
    transform: "translate(49 21)",
    fill: "#707070",
    fontSize: 14,
    fontFamily: "AtkinsonHyperlegible-Bold, Atkinson Hyperlegible",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -64,
    y: 0
  }, "Descargar planillas"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadSpreadsheet);
export default __webpack_public_path__ + "static/media/icon_download_spreadsheet.7c9d83a59503d0c8d1810433c655efdd.svg";
export { ForwardRef as ReactComponent };